var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHomeHousesMini(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 48,
    viewBox: "0 0 74 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3737 10.1196V14.7129L15.6263 11.4832V10.4785L12.3737 10.1196Z",
    fill: "#CA7485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6.7464L8.69697 19.8086H10.8889V23.6124L0 26.3397L12.0909 24.2584V17.8708L21.4242 7.9665L21 6.7464Z",
    fill: "#CA7485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7273 16.579L19.798 14.8565L21.4242 14.9282L21.3535 16.6507L19.7273 16.579Z",
    fill: "#E8A8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5252 20.0957L53.5959 18.6603L54.9394 18.732L54.8687 20.1675L53.5252 20.0957Z",
    fill: "#E8A8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7273 18.6603L19.798 16.9378L21.4242 17.0096L21.3535 18.7321L19.7273 18.6603Z",
    fill: "#E8A8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1515 21.9617L55.2222 20.5263L56.5657 20.5981L56.4949 22.0335L55.1515 21.9617Z",
    fill: "#E8A8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 18.7321L21.7778 17.0096L23.404 17.0814L23.3333 18.7321H21.7071Z",
    fill: "#E8A8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4545 21.8899L53.5252 20.4545L54.8687 20.5263L54.798 21.9617L53.4545 21.8899Z",
    fill: "#E8A8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7778 16.6507L21.8485 14.9282L23.4748 15L23.404 16.7225L21.7778 16.6507Z",
    fill: "#E8A8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2929 20.1674L55.3636 18.732L56.7071 18.8038L56.6364 20.2392L55.2929 20.1674Z",
    fill: "#E8A8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7778 6.10049L32.5253 10.9091L39.3131 20.6699H39.8788L46.6667 12.7751L55.3636 10.4785L46.4546 20.5263V22.0335L32.3838 21.1723V20.0957L21.7778 6.10049Z",
    fill: "#E8A8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0808 3.01435L53.8081 0L40.3737 15.6459L36.6263 15.3589L33.7273 11.1244L41.0808 3.01435Z",
    fill: "#E8A8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7475 6.45935V7.39237L62.5051 11.6986L62.7172 6.8182L59.7475 6.45935Z",
    fill: "#CA7485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8687 0.645905L53.8788 1.65069L62.7172 15.5024V17.9426L65.899 18.1579L54.8687 0.645905Z",
    fill: "#CA7485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1212 25.1196C36.1313 25.1196 35.0707 25.1196 34.0808 25.1914C15.202 25.8373 0 29.2823 0 29.2823C0 29.2823 15.202 27.1292 34.0808 26.4833C35.4242 26.4115 36.697 26.4115 38.0404 26.4115C55.2929 26.4115 70.0707 30 70.0707 30C70.0707 30 54.7273 25.1196 37.1212 25.1196Z",
    fill: "#CA7485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5656 11.0526L55.6465 12.0574L61.9394 21.6746V26.8421L69.4343 29.4258L62.2929 26.3397L62.505 23.6124H64.7677L56.5656 11.0526Z",
    fill: "#CA7485"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 37,
    y: 43.5,
    textAnchor: "middle",
    fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 12.8,
    fontWeight: 700,
    letterSpacing: 0.12,
    fill: "#CA7485"
  }, "Home")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHomeHousesMini);
export default __webpack_public_path__ + "static/media/logo-home-houses-mini.e39e0e52c26b3b3bc83ee8c06f83c199.svg";
export { ForwardRef as ReactComponent };